import { useFormik } from "formik";
import { FundingForm } from "../types";
import InputField from "./InputField";
import { step1Schema } from "./formSchema";

interface CompanyDetailsProps {
  onNext: (values: Partial<FundingForm>) => void;
  initialData: FundingForm;
  onFieldChange: (field: keyof FundingForm, value: any) => void;
}

const CompanyDetails = ({
  onNext,
  initialData,
  onFieldChange,
}: CompanyDetailsProps) => {
  const formik = useFormik({
    initialValues: {
      businessName: initialData.businessName,
      website: initialData.website,
      businessEmail: initialData.businessEmail,
    },
    validationSchema: step1Schema,
    onSubmit: (values) => {
      onNext(values);
    },
  });

  const handleChange = (e: React.ChangeEvent<any>) => {
    formik.handleChange(e);
    onFieldChange(e.target.name as keyof FundingForm, e.target.value);
  };

  return (
    <form onSubmit={formik.handleSubmit} className='flex flex-col'>
      <h2 className='text-2xl text-blueShades-4 font-bold pb-2'>
        Company Details
      </h2>
      <p className='text-sm text-ashShade-16'>Tell us about your company</p>
      <div className='flex flex-col pt-6'>
        <div className='pb-6'>
          <InputField
            type='string'
            name='businessName'
            labelText='Business Name'
            placeholder='e.g Example'
            onChange={handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.businessName}
            error={
              formik.touched.businessName ? formik.errors.businessName : ""
            }
            isRequired
          />
        </div>
        <div className='pb-6'>
          <InputField
            type='string'
            name='website'
            labelText='Website'
            placeholder='e.g www.example.com'
            onChange={handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.website || ""}
            error={formik.touched.website ? formik.errors.website : ""}
          />
        </div>
        <div className='pb-6'>
          <InputField
            type='email'
            name='businessEmail'
            labelText='Email Address'
            placeholder='e.g johndoe@example.com'
            onChange={handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.businessEmail}
            error={
              formik.touched.businessEmail ? formik.errors.businessEmail : ""
            }
            isRequired
          />
        </div>
      </div>
      <div className='flex gap-6 items-center  self-end'>
        <button
          type='submit'
          className='bg-blueShades-6 border border-blueShades-6 px-[18px] py-[9px] text-sm text-white rounded-lg'
        >
          Next
        </button>
      </div>
    </form>
  );
};
export default CompanyDetails;
